<template>
  <b-container style="width:380px;">
    <b-card header="Login" style="height:350px">
      <b-form @submit="onSubmit">
        <transition name="slide-fade" mode="out-in">
          <div v-if="show_target" key="email">
            <br/>
            <small class="text-muted" v-if="connection === 'sms'"> Enter your mobile or
              <a href="" @click.prevent="connection = 'email'">use your email</a></small>
            <small class="text-muted" v-if="connection === 'email'"> Enter your email or
              <a href="" @click.prevent="connection = 'sms'">use your mobile</a></small>
            <b-input-group class="my-3">
              <b-input-group-prepend is-text>
                <font-awesome-icon fixed-width :icon="icon"/>
              </b-input-group-prepend>
              <b-input name="target" v-model="target" :placeholder="placeholder" autofocus></b-input>
            </b-input-group>
          </div>
          <div v-else key="code">
            <small class="text-muted"> A message with the code has been sent to {{target}}.</small>
            <b-input-group class="my-3">
              <b-input-group-prepend is-text>
                <font-awesome-icon :icon="icon"/>
              </b-input-group-prepend>
              <b-input v-model="code" placeholder="your code" autocomplete="one-time-code" autofocus></b-input>
            </b-input-group>
          </div>
        </transition>
        <vue-recaptcha v-if="show_target" ref="recaptcha" :sitekey=site_key @verify="onCaptchaVerified" @expired="onRecaptchaExpired"></vue-recaptcha>
        <b-button v-if="!show_target" @click="goBack" class="mr-2 mt-3" variant="outline-primary"> Back</b-button>
        <b-button class="mt-3" @click="onSubmit" variant="primary" :disabled="!isCaptchaVerified">Submit
          <b-spinner v-if="this.isSending" class="m-1" label="Spinning" small/>
        </b-button>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
import { getErrorMessage } from '@/utils/error-messages';

export default {
  components: {
    VueRecaptcha
  },
  data () {
    return {
      show_target: true,
      target: null,
      code: null,
      isSending: false,
      isAuthenticated: false,
      profile: {},
      connection: 'email',
      isCaptchaVerified: false,
      recaptcha_response: null
    }
  },
  watch: {
    'target': function (newName) {
      if (this.connection === 'sms') {
        if (newName && newName.length > 2 && !newName.match(/^\+1/)) {
          this.target = '+1' + newName
        }
      }
    }
  },
  computed: {
    icon: function () {
      if (this.connection === 'sms') {
        return ['fa', 'mobile-alt']
      } else {
        return ['fa', 'envelope']
      }
    },
    placeholder: function () {
      if (this.connection === 'sms') {
        return '+15551231234'
      } else {
        return 'yours@example.com'
      }
    },
    site_key: function() {
      return process.env.VUE_APP_RECAPTCHA_KEY
    }
  },
  methods: {
    goBack () {
      this.code = null
      this.show_target = true
      this.isCaptchaVerified = false
    },
    onSubmit (evt) {
      evt.preventDefault()

      if (this.isCaptchaVerified) {

        if (this.show_target === true) {
        this.createMagic()
      } else {
        this.login()
      }
      }
      else {
        this.$bvToast.toast("Captcha Not Verified", { title: 'Alert', solid: true, variant: 'danger', autoHideDelay: 5000, appendToast: true })
      }
    },
    async createMagic () {
      this.isSending = true
      try {
        await this.$auth.createMagic(this.connection, this.target, this.recaptcha_response)
        this.show_target = false
      } catch (error) {
        // getErrorMessage guards missing error.response — the old statusText deref
        // threw inside the catch on a network error, so no toast ever showed.
        this.$bvToast.toast(getErrorMessage(error), { title: 'Alert', solid: true, variant: 'danger', autoHideDelay: 5000, appendToast: true })
        this.show_target = true
      }
      this.isSending = false
    },
    async login () {
      this.isSending = true
      await this.$auth.login(this.connection, this.target, this.code)
        .catch(error => {
          this.$bvToast.toast(getErrorMessage(error), { title: 'Alert', solid: true, variant: 'danger', autoHideDelay: 5000, appendToast: true })
        })
      this.isSending = false
      this.$router.push({ path: this.$route.query.redirect || '/course' })
    },
    handleLoginEvent (data) {
      this.isAuthenticated = data.loggedIn
      this.profile = data.profile
    },
    onCaptchaVerified(response) {
      // Enable form submission when CAPTCHA challenge is successfully completed
      if (response) {
        this.recaptcha_response = response;
        this.isCaptchaVerified = true;
      }
    },
    onRecaptchaExpired(){
      this.isCaptchaVerified = false;
    }
  }
}
</script>

<style>
  .slide-fade-enter-active {
    transition: all .4s ease;
  }

  .slide-fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter {
    transform: translateX(20px);
    opacity: 0;
  }

  .slide-fade-leave-to {
    transform: translateX(-20px);
    opacity: 0;
  }
</style>
